import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    visibleActualsActivities: [],
};

export const actualsActivitiesSlice = createSlice({
    name: 'actualsActivities',
    initialState,
    reducers: {
        setActualsActivities: (state, action) => {
            state.visibleActualsActivities = action.payload;
        },
    },
});

export const { setActualsActivities } = actualsActivitiesSlice.actions;

export default actualsActivitiesSlice.reducer;
